import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IConfirmacaoHorarioProps } from "../../../../types/agendamento";

export const useDefinirHorario = () => {
  return useMutation({
    mutationFn: (data: IConfirmacaoHorarioProps) =>
      Agendamento.definirHorario(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
